module.exports = __webpack_public_path__ + "static/media/shopify4.7e726436.png";